
export const Blogs = [
    {
        id: "users_users_users",
        src: "/blogs/users-users-users",
        title: "Users Users Users",
        description: "How HQ Trivia drove 1.2 million live players using cash prizes, referral codes, a live feed, and the Hook Model — and what every business can learn from it.",
        bg: "bg-indigo-50",
        accent: "text-indigo-500",
        customTailwind: "col-span-6 lg:col-span-4",
        badge: "bg-indigo-100 text-indigo-700",
        icon: (
            <svg viewBox="0 0 56 56" fill="none" className="w-full h-full">
                <rect width="56" height="56" rx="28" fill="#e0e7ff"/>
                <circle cx="20" cy="26" r="6" fill="#6366f1" opacity="0.5"/>
                <circle cx="36" cy="26" r="6" fill="#6366f1" opacity="0.7"/>
                <circle cx="28" cy="34" r="6" fill="#6366f1" opacity="0.9"/>
                <path d="M14 44c0-4 3-6 6-6h16c3 0 6 2 6 6" stroke="#6366f1" strokeWidth="2" strokeLinecap="round" fill="none"/>
            </svg>
        ),
        mockup: (
            <div className="rounded-2xl border border-gray-100 shadow-sm p-4 space-y-3">
                <div className="grid grid-cols-2 gap-2 pb-3 border-b border-gray-100">
                    <div className="bg-indigo-50 rounded-xl p-2 text-center">
                        <p className="text-sm font-bold text-indigo-700">1.2M</p>
                        <p className="text-xs text-gray-500">Peak live players</p>
                    </div>
                    <div className="bg-indigo-50 rounded-xl p-2 text-center">
                        <p className="text-sm font-bold text-indigo-700">800K+</p>
                        <p className="text-xs text-gray-500">Concurrent at launch</p>
                    </div>
                </div>
                <div className="space-y-2">
                    {[
                        { phase: "Trigger", detail: "Push notification" },
                        { phase: "Action", detail: "Get ready to play" },
                        { phase: "Reward", detail: "Cash prize" },
                        { phase: "Investment", detail: "Answer & return" },
                    ].map((row) => (
                        <div key={row.phase} className="flex items-center justify-between text-xs">
                            <span className="font-medium text-indigo-600">{row.phase}</span>
                            <span className="text-gray-400">{row.detail}</span>
                        </div>
                    ))}
                </div>
            </div>
        ),
    },
    {
        id: "cart_abandonment",
        src: "/solutions/shopify-cart-abandonment-solutions",
        title: "Cart Abandonment",
        description: "Most customers who leave without buying aren't gone forever. Learn how store credit can bring them back and turn abandoned carts into completed orders.",
        bg: "bg-red-50",
        accent: "text-rose-500",
        customTailwind: "col-span-6 lg:col-span-2",
        badge: "bg-rose-100 text-rose-700",
        icon: (
            <svg viewBox="0 0 56 56" fill="none" className="w-full h-full">
                <rect width="56" height="56" rx="28" fill="#ffe4e6"/>
                <path d="M16 18h24l-3 12H19L16 18z" fill="#f43f5e" opacity="0.7"/>
                <circle cx="22" cy="34" r="2" fill="#f43f5e"/>
                <circle cx="34" cy="34" r="2" fill="#f43f5e"/>
                <path d="M12 14h3l1 4" stroke="#f43f5e" strokeWidth="2" strokeLinecap="round"/>
                <path d="M28 22v6M25 25h6" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
        ),
        mockup: (
            <div className="rounded-2xl border border-gray-100 shadow-sm p-4 space-y-3">
                <div className="flex items-center justify-between pb-2 border-b border-gray-100">
                    <span className="text-xs text-gray-500">Abandoned carts this week</span>
                    <span className="text-xs font-semibold text-rose-600">143</span>
                </div>
                {[
                    { name: "Jamie L.", cart: "$94.00", status: "Credit sent", cls: "bg-green-100 text-green-700" },
                    { name: "Priya M.", cart: "$47.50", status: "Pending", cls: "bg-amber-100 text-amber-700" },
                    { name: "Derek S.", cart: "$120.00", status: "Credit sent", cls: "bg-green-100 text-green-700" },
                ].map((r) => (
                    <div key={r.name} className="flex items-center justify-between">
                        <div>
                            <p className="text-xs font-medium text-gray-800">{r.name}</p>
                            <p className="text-xs text-gray-400">Cart value: {r.cart}</p>
                        </div>
                        <span className={`text-xs px-2 py-0.5 rounded-full ${r.cls}`}>{r.status}</span>
                    </div>
                ))}
            </div>
        ),
    },
    {
        id: "feed",
        src: "/solutions/shopify/cashback/free-shopify-cashback-app",
        title: "🚀 What differentiates small business from big business?",
        description: "It's not budget or headcount. The merchants who win are the ones who make customers feel like they matter. Here's how store credit closes that gap.",
        bg: "bg-blue-50",
        accent: "text-sky-500",
        customTailwind: "col-span-6 lg:col-span-4",
        badge: "bg-sky-100 text-sky-700",
        icon: (
            <svg viewBox="0 0 56 56" fill="none" className="w-full h-full">
                <rect width="56" height="56" rx="28" fill="#e0f2fe"/>
                <rect x="14" y="18" width="12" height="20" rx="2" fill="#0ea5e9" opacity="0.4"/>
                <rect x="30" y="10" width="12" height="28" rx="2" fill="#0ea5e9" opacity="0.8"/>
                <path d="M14 38l10-8 8 4 10-12" stroke="#0ea5e9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
            </svg>
        ),
        mockup: (
            <div className="rounded-2xl border border-gray-100 shadow-sm p-4 space-y-3">
                <div className="grid grid-cols-2 gap-2 pb-3 border-b border-gray-100">
                    <div className="bg-sky-50 rounded-xl p-2 text-center">
                        <p className="text-sm font-bold text-sky-700">68%</p>
                        <p className="text-xs text-gray-500">Repeat purchase rate</p>
                    </div>
                    <div className="bg-sky-50 rounded-xl p-2 text-center">
                        <p className="text-sm font-bold text-sky-700">3.2x</p>
                        <p className="text-xs text-gray-500">LTV vs no credit</p>
                    </div>
                </div>
                <p className="text-xs text-gray-500 leading-relaxed">Merchants using store credit see customers return twice as often and spend significantly more per visit compared to discount-only strategies.</p>
            </div>
        ),
    },
    {
        id: "store_credit_vs_discounts",
        src: "/solutions/shopify/cashback/shopify-cashback-vs-discounts",
        title: "Store Credit vs Discounts",
        description: "Discounts kill margin and train customers to wait for a sale. Store credit rewards loyalty and keeps revenue inside your store. Here's why the difference matters.",
        bg: "bg-purple-50",
        accent: "text-violet-500",
        customTailwind: "col-span-6 lg:col-span-3",
        badge: "bg-violet-100 text-violet-700",
        icon: (
            <svg viewBox="0 0 56 56" fill="none" className="w-full h-full">
                <rect width="56" height="56" rx="28" fill="#ede9fe"/>
                <rect x="12" y="20" width="14" height="18" rx="2" fill="#7c3aed" opacity="0.4"/>
                <rect x="30" y="20" width="14" height="18" rx="2" fill="#7c3aed" opacity="0.8"/>
                <path d="M19 29h0M37 24v10" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                <path d="M34 27l3 3 3-3" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        ),
        mockup: (
            <div className="rounded-2xl border border-gray-100 shadow-sm p-4 space-y-3">
                {[
                    { label: "Revenue retained", discount: "0%", credit: "100%" },
                    { label: "Customer returns", discount: "Low", credit: "High" },
                    { label: "Margin impact", discount: "High", credit: "Low" },
                    { label: "Trains sale-waiting", discount: "Yes", credit: "No" },
                ].map((row) => (
                    <div key={row.label} className="flex items-center justify-between text-xs">
                        <span className="text-gray-500 w-32">{row.label}</span>
                        <span className="text-rose-500 w-14 text-center">{row.discount}</span>
                        <span className="text-violet-600 font-medium w-14 text-center">{row.credit}</span>
                    </div>
                ))}
                <div className="flex justify-end gap-4 pt-1 border-t border-gray-100">
                    <span className="text-xs text-rose-400">Discounts</span>
                    <span className="text-xs text-violet-600 font-medium">Store Credit</span>
                </div>
            </div>
        ),
    },
    {
        id: "top_3_cashback_examples",
        src: "/solutions/shopify/cashback/shopify-cashback-examples",
        title: "Top 3 Cashback Examples",
        description: "Three real-world cashback setups that drive repeat purchases, increase order value, and keep customers coming back, without touching your margins.",
        bg: "bg-green-50",
        accent: "text-emerald-500",
        customTailwind: "col-span-6 lg:col-span-3",
        badge: "bg-emerald-100 text-emerald-700",
        icon: (
            <svg viewBox="0 0 56 56" fill="none" className="w-full h-full">
                <rect width="56" height="56" rx="28" fill="#d1fae5"/>
                <circle cx="20" cy="28" r="5" fill="#10b981" opacity="0.5"/>
                <circle cx="32" cy="22" r="5" fill="#10b981" opacity="0.7"/>
                <circle cx="40" cy="30" r="5" fill="#10b981" opacity="0.9"/>
                <path d="M16 40l8-6 8 3 8-8" stroke="#059669" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
            </svg>
        ),
        mockup: (
            <div className="rounded-2xl border border-gray-100 shadow-sm p-4 space-y-3">
                {[
                    { num: "01", title: "Flat rate cashback", detail: "5% back on every order" },
                    { num: "02", title: "Tiered cashback", detail: "More you spend, more you earn" },
                    { num: "03", title: "First order cashback", detail: "Hook new customers immediately" },
                ].map((ex) => (
                    <div key={ex.num} className="flex items-center gap-3 pb-3 border-b border-gray-50 last:border-0 last:pb-0">
                        <span className="text-xs font-bold text-emerald-300 w-6 shrink-0">{ex.num}</span>
                        <div>
                            <p className="text-xs font-semibold text-gray-800">{ex.title}</p>
                            <p className="text-xs text-gray-400">{ex.detail}</p>
                        </div>
                    </div>
                ))}
            </div>
        ),
    },
    {
        id: "no_more_chargebacks",
        src: "/solutions/shopify/no-more-chargebacks",
        title: "No more chargebacks.",
        description: "Chargebacks cost you money, damage your payment processor standing, and are almost always avoidable. Here's how store credit resolves disputes before they escalate.",
        bg: "bg-amber-50",
        accent: "text-amber-500",
        customTailwind: "col-span-6 lg:col-span-6",
        badge: "bg-amber-100 text-amber-700",
        icon: (
            <svg viewBox="0 0 56 56" fill="none" className="w-full h-full">
                <rect width="56" height="56" rx="28" fill="#fef3c7"/>
                <circle cx="28" cy="28" r="12" fill="#f59e0b" opacity="0.3"/>
                <path d="M28 20v9" stroke="#92400e" strokeWidth="2.5" strokeLinecap="round"/>
                <circle cx="28" cy="33" r="1.5" fill="#92400e"/>
                <path d="M20 44h16" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" opacity="0.5"/>
            </svg>
        ),
        mockup: (
            <div className="rounded-2xl border border-gray-100 shadow-sm p-4 space-y-3">
                <div className="grid grid-cols-3 gap-2 pb-3 border-b border-gray-100">
                    <div className="bg-amber-50 rounded-xl p-2 text-center">
                        <p className="text-sm font-bold text-amber-700">$0</p>
                        <p className="text-xs text-gray-500">Chargeback fees</p>
                    </div>
                    <div className="bg-amber-50 rounded-xl p-2 text-center">
                        <p className="text-sm font-bold text-amber-700">94%</p>
                        <p className="text-xs text-gray-500">Disputes resolved</p>
                    </div>
                    <div className="bg-amber-50 rounded-xl p-2 text-center">
                        <p className="text-sm font-bold text-amber-700">2 min</p>
                        <p className="text-xs text-gray-500">Avg resolution</p>
                    </div>
                </div>
                {[
                    { issue: "Item not received — Alex T.", action: "Credit issued", cls: "bg-green-100 text-green-700" },
                    { issue: "Wrong item — Maria C.", action: "Credit issued", cls: "bg-green-100 text-green-700" },
                    { issue: "Late delivery — Sam W.", action: "Goodwill credit", cls: "bg-green-100 text-green-700" },
                ].map((r) => (
                    <div key={r.issue} className="flex items-center justify-between">
                        <span className="text-xs text-gray-500">{r.issue}</span>
                        <span className={`text-xs px-2 py-0.5 rounded-full ${r.cls}`}>{r.action}</span>
                    </div>
                ))}
            </div>
        ),
    },
    {
        id: "inventory_liquidation_101",
        src: "/solutions/shopify/inventory-liquidation",
        title: "Get Rid of It All - Inventory Liquidation 101",
        description: "Sitting on slow-moving stock? Instead of slashing prices and killing margin, use store credit incentives to move inventory while guaranteeing customers return to spend it.",
        bg: "bg-orange-50",
        accent: "text-orange-500",
        customTailwind: "col-span-6 lg:col-span-2",
        badge: "bg-orange-100 text-orange-700",
        icon: (
            <svg viewBox="0 0 56 56" fill="none" className="w-full h-full">
                <rect width="56" height="56" rx="28" fill="#ffedd5"/>
                <rect x="14" y="26" width="8" height="16" rx="1" fill="#f97316" opacity="0.4"/>
                <rect x="24" y="20" width="8" height="22" rx="1" fill="#f97316" opacity="0.6"/>
                <rect x="34" y="14" width="8" height="28" rx="1" fill="#f97316" opacity="0.9"/>
                <path d="M12 42h32" stroke="#f97316" strokeWidth="1.5" strokeLinecap="round" opacity="0.4"/>
            </svg>
        ),
        mockup: (
            <div className="rounded-2xl border border-gray-100 shadow-sm p-4 space-y-3">
                {[
                    { product: "Winter Jackets", stock: "84 units", credit: "+$20 credit", cls: "bg-orange-100 text-orange-700" },
                    { product: "Last season tees", stock: "210 units", credit: "+$8 credit", cls: "bg-orange-100 text-orange-700" },
                    { product: "Overstocked mugs", stock: "56 units", credit: "+$5 credit", cls: "bg-orange-100 text-orange-700" },
                ].map((r) => (
                    <div key={r.product} className="flex items-center justify-between pb-3 border-b border-gray-50 last:border-0 last:pb-0">
                        <div>
                            <p className="text-xs font-medium text-gray-800">{r.product}</p>
                            <p className="text-xs text-gray-400">{r.stock}</p>
                        </div>
                        <span className={`text-xs px-2 py-0.5 rounded-full ${r.cls}`}>{r.credit}</span>
                    </div>
                ))}
            </div>
        ),
    },
    {
        id: "analytics",
        title: "Analytics",
        description: "Know exactly who has credit, how much, and what they're doing with it. Track issuance, redemption rates, and customer behaviour to make smarter decisions.",
        bg: "bg-blue-50",
        accent: "text-blue-500",
        customTailwind: "col-span-6 lg:col-span-2",
        badge: "bg-blue-100 text-blue-700",
        icon: (
            <svg viewBox="0 0 56 56" fill="none" className="w-full h-full">
                <rect width="56" height="56" rx="28" fill="#dbeafe"/>
                <rect x="14" y="34" width="6" height="10" rx="2" fill="#3b82f6" opacity="0.4"/>
                <rect x="23" y="26" width="6" height="18" rx="2" fill="#3b82f6" opacity="0.6"/>
                <rect x="32" y="18" width="6" height="26" rx="2" fill="#3b82f6" opacity="0.9"/>
                <path d="M14 28l8-6 9-4 9-8" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" fill="none"/>
            </svg>
        ),
        mockup: (
            <div className="rounded-2xl border border-gray-100 shadow-sm p-4 space-y-3">
                <div className="grid grid-cols-3 gap-2">
                    {[["$24,800", "Credit issued"], ["81%", "Redeemed"], ["2.4x", "Avg ROI"]].map(([val, label]) => (
                        <div key={label} className="bg-blue-50 rounded-xl p-2 text-center">
                            <p className="text-sm font-bold text-blue-700">{val}</p>
                            <p className="text-xs text-gray-500">{label}</p>
                        </div>
                    ))}
                </div>
                <div className="space-y-1.5">
                    <p className="text-xs text-gray-400">Redemption by week</p>
                    <div className="flex items-end gap-1.5 h-12">
                        {[40, 60, 50, 80, 70, 95, 75].map((h, i) => (
                            <div key={i} className="flex-1 rounded-sm bg-blue-100 relative" style={{ height: `${h}%` }}>
                                {i === 5 && <div className="absolute inset-0 bg-blue-500 rounded-sm" />}
                            </div>
                        ))}
                    </div>
                    <div className="flex justify-between text-xs text-gray-300">
                        {["M","T","W","T","F","S","S"].map((d, i) => <span key={i}>{d}</span>)}
                    </div>
                </div>
            </div>
        ),
    },
    {
        id: "monetization",
        title: "Monetization",
        description: "Store credit isn't just a retention tool, it's a revenue model. Sell credit upfront, bundle it into memberships, or use it to unlock higher customer lifetime value.",
        bg: "bg-teal-50",
        accent: "text-teal-500",
        customTailwind: "col-span-6 lg:col-span-2",
        badge: "bg-teal-100 text-teal-700",
        icon: (
            <svg viewBox="0 0 56 56" fill="none" className="w-full h-full">
                <rect width="56" height="56" rx="28" fill="#ccfbf1"/>
                <circle cx="28" cy="28" r="13" fill="#14b8a6" opacity="0.3"/>
                <text x="28" y="33" textAnchor="middle" fontSize="16" fill="#0f766e" fontWeight="bold">$</text>
                <path d="M28 11v4M28 41v4M11 28h4M41 28h4" stroke="#14b8a6" strokeWidth="2.5" strokeLinecap="round"/>
            </svg>
        ),
        mockup: (
            <div className="rounded-2xl border border-gray-100 shadow-sm p-4 space-y-3">
                {[
                    { model: "Sell credit upfront", detail: "Customer buys $100 credit for $85", tag: "Prepaid" },
                    { model: "Bundle into membership", detail: "$20 credit included monthly", tag: "Recurring" },
                    { model: "Unlock with spend", detail: "$10 credit at $100 order threshold", tag: "Threshold" },
                ].map((m) => (
                    <div key={m.model} className="flex items-start justify-between gap-2 pb-3 border-b border-gray-50 last:border-0 last:pb-0">
                        <div>
                            <p className="text-xs font-semibold text-gray-800">{m.model}</p>
                            <p className="text-xs text-gray-400">{m.detail}</p>
                        </div>
                        <span className="text-xs bg-teal-100 text-teal-700 px-2 py-0.5 rounded-full shrink-0">{m.tag}</span>
                    </div>
                ))}
            </div>
        ),
    },
];